import React from 'react'
import styles from "./fail.module.css";
import { Icon } from "@iconify/react";

function Fail() {

return (
    <div className={styles.body}>


        <div className={styles.gracias}>

        <h1>error</h1>
        <p></p>
        </div>
   
    </div>

  )
}
export default Fail;